import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpErrorResponse,
} from '@angular/common/http';
import {
  catchError,
  delay,
  map,
  Observable,
  retry,
  retryWhen,
  scan,
  tap,
  throwError,
  timer,
} from 'rxjs';
import { DatePipe } from '@angular/common';
import { LoginService } from '../home/login.service';

import { ICustomer } from '../home/customer';
import { ICardData } from './carddata';
import { INexioSaveCardResponse } from './nexiosavecardresponse';
import { INexioToken } from './nexiotoken';
import { INexioTransactionResponse } from './nexiotransactionresponse';
import { IAddressVM } from '../account/addressViewModel';
import { IOnlineOrderAddressUpdate } from '../account/updateOnlineOrderAddressResponse';

@Injectable()
export class CheckoutService {
  private _updateOnlineOrderAddressUrl =
    'https://samplecart.lbri.net/api/api/UpdateOnlineOrderAddress/';
  private _CCPaymentUrl =
    'https://samplecart.lbri.net/api/api/OnlinePaymentsCC/';
  private _ACHPaymentUrl =
    'https://samplecart.lbri.net/api/api/OnlinePaymentsACH/';
  private checkCCUrl = 'https://samplecart.lbri.net/api/api/CheckCCNumber/';
  private sendARUrl = 'https://samplecart.lbri.net/api/api/GenerateAR?orderid=';
  private updateShippingAddressURL =
    'https://webapi.securefreedom.com/Lbri/api/personal/order/OnlineOrder';
  private checkRoutingNumUrl =
    'https://samplecart.lbri.net/api/api/CheckRoutingNumber/';
  private _getShippingAddressUrl =
    'https://webapi.securefreedom.com/Lbri/api/order/Address?customerDID=';
  constructor(
    private _http: HttpClient,
    private login: LoginService,
    private datePipe: DatePipe
  ) {}
  public lbriAPI: any;
  public addressVm!: IAddressVM;

  updateOnlineOrderAddress() {
    const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...
        
    let orderInfo = JSON.parse(localStorage.getItem('orderId'));
    let shipData = JSON.parse(localStorage.getItem('shippingData'));
    let repId = localStorage.getItem('repId');
    let custInfo = JSON.parse(localStorage.getItem('allCustInfo'));
    let custEmail =
      JSON.parse(localStorage.getItem('emailAddress')) !== null
        ? JSON.parse(localStorage.getItem('emailAddress'))
        : null;
    let myHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      scope: 'write',
      Authorization: 'Basic ' + btoa('postcardapi:6TfC5RdX$$'),
    });

    let httpOptionsNew = {
      headers: myHeaders,
    };

    //let url = 'https://webapi.bydesign.com/Lbri/api/order/OnlineOrder/ValidateOrderItems?onlineOrderID=' + orderInfo.ID;
    let _body = {
      onlineOrderId: orderInfo.ID,
      shippingAddress: {
        Description: 'ShippingAddress',
        Company: '',
        Street1: shipData.street1,
        Street2: shipData.street2,
        City: shipData.city,
        State: shipData.state,
        PostalCode: shipData.zip,
        County: shipData.county,
        Country: 'USA',
        Phone: shipData.phone !== '' ? shipData.phone : '2620000000',
        Email:
          shipData.email !== ''
            ? shipData.email
            : custInfo.CustomerDID + '@lbri.com',
        FirstName: shipData.first,
        LastName: shipData.last,
        IsOverrideAddress: true,
      },
      billingAddress: {
        Description: 'BillingAddress',
        Company: '',
        Street1: shipData.street1,
        Street2: shipData.street2,
        City: shipData.city,
        State: shipData.state,
        PostalCode: shipData.zip,
        County: shipData.county,
        Country: 'USA',
        Phone: shipData.phone !== '' ? shipData.phone : '2620000000',
        Email:
          shipData.email !== ''
            ? shipData.email
            : custInfo.CustomerDID + '@lbri.com',
        FirstName: shipData.first,
        LastName: shipData.last,
      },
      partyGUID: '',
      useValidation: false,
    };

    return this._http
      .put<IOnlineOrderAddressUpdate>(
        this.updateShippingAddressURL +
          '?repDID=' +
          repId +
          '&useValidation=false',
        _body,
        httpOptionsNew
      )
      .pipe(
         retry({
                                count: MAX_RETRIES,
                                delay: (error: HttpErrorResponse, retryCount: number) => {
                                    // Retry only on transient failures
                                    const status = error.status;
                
                                    const isTransient =
                                        status === 0 ||                 // network / CORS / DNS / offline
                                        status === 429 ||               // rate limit
                                        (status >= 500 && status < 600); // server errors
                
                                    if (!isTransient) {
                                        return throwError(() => error);
                                    }
                
                                    // exponential backoff with cap
                                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                    return timer(backoff);
                                }
                            }),
        catchError(this.handleError)
      );
  }

  updateOnlineOrderAddress2(
    first: string | null,
    last: string | null,
    phone: string | null,
    email: string | null,
    street1: string | null,
    street2: string | null,
    city: string | null,
    state: string | null,
    zip: string | null,
    county: string | null
  ) {
    const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

    let orderInfo = JSON.parse(localStorage.getItem('orderId'));
    let shipData = JSON.parse(localStorage.getItem('shippingData'));
    let repId = localStorage.getItem('repId');
    let custInfo = JSON.parse(localStorage.getItem('allCustInfo'));
    let custEmail =
      JSON.parse(localStorage.getItem('emailAddress')) !== null
        ? JSON.parse(localStorage.getItem('emailAddress'))
        : null;
    let myHeaders = new HttpHeaders({
      'Content-Type': 'application/json',
      scope: 'write',
      Authorization: 'Basic ' + btoa('postcardapi:6TfC5RdX$$'),
    });

    let httpOptionsNew = {
      headers: myHeaders,
    };

    //let url = 'https://webapi.bydesign.com/Lbri/api/order/OnlineOrder/ValidateOrderItems?onlineOrderID=' + orderInfo.ID;
    let _body = {
      onlineOrderId: orderInfo.ID,
      shippingAddress: {
        Description: 'ShippingAddress',
        Company: '',
        Street1: street1,
        Street2: street2,
        City: city,
        State: state,
        PostalCode: zip,
        County: county,
        Country: 'USA',
        Phone: phone !== '' ? phone : '2620000000',
        Email: email !== '' ? email : custInfo.CustomerDID + '@lbri.com',
        FirstName: first,
        LastName: last,
        IsOverrideAddress: true,
      },
      billingAddress: {
        Description: 'BillingAddress',
        Company: '',
        Street1: street1,
        Street2: street2,
        City: city,
        State: state,
        PostalCode: zip,
        County: county,
        Country: 'USA',
        Phone: phone !== '' ? phone : '2620000000',
        Email: email !== '' ? email : custInfo.CustomerDID + '@lbri.com',
        FirstName: first,
        LastName: last,
      },
      partyGUID: '',
      useValidation: false,
    };

    return this._http
      .put<IOnlineOrderAddressUpdate>(
        this.updateShippingAddressURL +
          '?repDID=' +
          repId +
          '&useValidation=false',
        _body,
        httpOptionsNew
      )
      .pipe(
         retry({
                                count: MAX_RETRIES,
                                delay: (error: HttpErrorResponse, retryCount: number) => {
                                    // Retry only on transient failures
                                    const status = error.status;
                
                                    const isTransient =
                                        status === 0 ||                 // network / CORS / DNS / offline
                                        status === 429 ||               // rate limit
                                        (status >= 500 && status < 600); // server errors
                
                                    if (!isTransient) {
                                        return throwError(() => error);
                                    }
                
                                    // exponential backoff with cap
                                    const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                    return timer(backoff);
                                }
                            }),
        catchError(this.handleError)
      );
  }

  checkCCNumber(ccNum: string | null) {
    const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...
    //var currentOrderID = JSON.parse(localStorage.getItem('orderId'));

    let headers = new HttpHeaders({
      scope: 'write',
      //'content-type':  'application/x-www-form-urlencoded'
      'content-type': 'application/json',
      //'Authorization': "Bearer " + this.login.token
    });

    let options = {
      headers: headers,
    };

    let _body = {
      CreditCardNumber: ccNum,
    };

    return this._http
      .post(this.checkCCUrl, _body, options)
      .pipe(catchError(this.handleError));
  }

  checkRoutingNumber(routingNum: string | null) {
    const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...
    //var currentOrderID = JSON.parse(localStorage.getItem('orderId'));

    let headers = new HttpHeaders({
      scope: 'write',
      //'content-type':  'application/x-www-form-urlencoded'
      'content-type': 'application/json',
      //'Authorization': "Bearer " + this.login.token
    });

    let options = {
      headers: headers,
    };

    let _body = {
      RoutingNumber: routingNum,
    };

    return this._http
      .post(this.checkRoutingNumUrl, _body, options)
      .pipe( retry({
                              count: MAX_RETRIES,
                              delay: (error: HttpErrorResponse, retryCount: number) => {
                                  // Retry only on transient failures
                                  const status = error.status;
              
                                  const isTransient =
                                      status === 0 ||                 // network / CORS / DNS / offline
                                      status === 429 ||               // rate limit
                                      (status >= 500 && status < 600); // server errors
              
                                  if (!isTransient) {
                                      return throwError(() => error);
                                  }
              
                                  // exponential backoff with cap
                                  const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                  return timer(backoff);
                              }
                          }),catchError(this.handleError));
  }
  sendAR(custid: string) {
    this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken') || '{}');
    var myOrderID = JSON.parse(
      localStorage.getItem('completedOrderId') || '{}'
    );

    let headers = new HttpHeaders({
      scope: 'write',
      //'content-type':  'application/x-www-form-urlencoded'
      'content-type': 'application/json',
      Authorization: 'Bearer ' + this.lbriAPI.access_token,
    });

    let options = {
      headers: headers,
    };

    let _body = {
      CustId: custid.replace('-->c_', ''),
    };

    return this._http
      .post(this.sendARUrl + myOrderID, _body, options)
      .pipe(catchError(this.handleError));
  }

  updateShippingAddress(
    first: string | null,
    last: string | null,
    phone: string | null,
    email: string | null,
    street1: string | null,
    city: string | null,
    state: string | null,
    zip: string | null,
    county: string | null
  ) {
    const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken') || '{}');
    let headers = new HttpHeaders({
      scope: 'write',
      //'content-type':  'application/x-www-form-urlencoded'
      'content-type': 'application/json',
      Authorization: 'Bearer ' + this.lbriAPI.access_token,
    });

    let options = {
      headers: headers,
    };

    let _body = {
      FirstName: first,
      LastName: last,
      Phone: phone,
      Email: email,
      Street1: street1,
      City: city,
      State: state,
      PostalCode: zip,
      County: county,
    };

    return this._http
      .post(
        this._updateOnlineOrderAddressUrl + currentOrderID.ID,
        _body,
        options
      )
      .pipe( retry({
                              count: MAX_RETRIES,
                              delay: (error: HttpErrorResponse, retryCount: number) => {
                                  // Retry only on transient failures
                                  const status = error.status;
              
                                  const isTransient =
                                      status === 0 ||                 // network / CORS / DNS / offline
                                      status === 429 ||               // rate limit
                                      (status >= 500 && status < 600); // server errors
              
                                  if (!isTransient) {
                                      return throwError(() => error);
                                  }
              
                                  // exponential backoff with cap
                                  const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                  return timer(backoff);
                              }
                          }),catchError(this.handleError));
  }

  getShippingAddress() {
    const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...

    var currentUser = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    let headers = new HttpHeaders({
      scope: 'write',
      //'content-type':  'application/x-www-form-urlencoded'
      'content-type': 'application/json',
      Authorization: 'Bearer ' + currentUser.access_token,
    });

    let options = {
      headers: headers,
    };

    return this._http
      .get<IAddressVM>(
        this._getShippingAddressUrl + currentUser.userName.replace('-->c_', ''),
        options
      )
      .pipe( 
        retry({
                              count: MAX_RETRIES,
                              delay: (error: HttpErrorResponse, retryCount: number) => {
                                  // Retry only on transient failures
                                  const status = error.status;
              
                                  const isTransient =
                                      status === 0 ||                 // network / CORS / DNS / offline
                                      status === 429 ||               // rate limit
                                      (status >= 500 && status < 600); // server errors
              
                                  if (!isTransient) {
                                      return throwError(() => error);
                                  }
              
                                  // exponential backoff with cap
                                  const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                  return timer(backoff);
                              }
                          }),
        map((data) => (this.addressVm = data)),
        tap((data) => {
          let first = data.addresses[1].FirstName;
          let last = data.addresses[1].LastName;
          let street1 = data.addresses[1].Street1;
          let city = data.addresses[1].City;
          let state = data.addresses[1].State;
          let zip = data.addresses[1].PostalCode;
          let county = data.addresses[1].County;
          let phone = data.addresses[1].Phone;
          let email = data.addresses[1].Email;
          if (street1) {
            localStorage.setItem(
              'shippingData',
              JSON.stringify({
                first: first,
                last: last,
                street1: street1,
                city: city,
                state: state,
                zip: zip,
                county: county,
                phone: phone,
                email: email,
              })
            );

            return data;
          } else {
            return false;
          }
        }),
        catchError(this.handleError)
      );
  }

  BDTCCStore(r: INexioTransactionResponse) {
    const MAX_RETRIES = 4;          // total attempts = 1 + MAX_RETRIES
        const BASE_DELAY_MS = 400;      // 0.4s, 0.8s, 1.6s, 3.2s ...
    let orderInfo = JSON.parse(localStorage.getItem('orderId') || '{}');
    this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken') || '{}');
    let headers = new HttpHeaders({
      scope: 'write',
      //'content-type':  'application/x-www-form-urlencoded'
      'content-type': 'application/json',
      Authorization: 'Bearer ' + this.lbriAPI.access_token,
    });

    let httpOptionsNew = {
      headers: headers,
    };

    let url =
      'https://samplecart.lbri.net/api/api/OnlinePaymentsCC/BDTTokenized?id=' +
      orderInfo.ID;

    let _body = {
      id: r.id,
      merchantId: r.merchantId,
      authCode: r.authCode,
      amount: r.amount,
      transactionID: r.id,
      transactionDate: r.transactionDate,
      transactionStatus: r.transactionStatus,
      transactionType: r.transactionType,
      cardNumber: r.card.cardNumber,
      cardExpirationDate: r.card.expirationMonth + '/' + r.card.expirationYear,
      cardHolder: r.card.cardHolder,
      cardType: r.card.cardType,
      cardFirstSix: r.token.firstSix,
      cardLastFour: r.token.lastFour,
      token: r.token.token,
      referenceNumber: r.gatewayResponse.refNumber,
    };

    return this._http.post<string>(url, _body, httpOptionsNew).pipe(
       retry({
                              count: MAX_RETRIES,
                              delay: (error: HttpErrorResponse, retryCount: number) => {
                                  // Retry only on transient failures
                                  const status = error.status;
              
                                  const isTransient =
                                      status === 0 ||                 // network / CORS / DNS / offline
                                      status === 429 ||               // rate limit
                                      (status >= 500 && status < 600); // server errors
              
                                  if (!isTransient) {
                                      return throwError(() => error);
                                  }
              
                                  // exponential backoff with cap
                                  const backoff = Math.min(BASE_DELAY_MS * Math.pow(2, retryCount - 1), 8000);
                                  return timer(backoff);
                              }
                          }),
      catchError(this.handleError)
    );
  }
  processCCPayment(
    first: string,
    last: string,
    street: string,
    zip: string,
    cc: string,
    month: string,
    year: string,
    cvv: string,
    amount: number
  ) {
    var currentOrderID = JSON.parse(localStorage.getItem('orderId') || '{}');
    this.lbriAPI = JSON.parse(localStorage.getItem('lbriToken') || '{}');
    let headers = new HttpHeaders({
      scope: 'write',
      //'content-type':  'application/x-www-form-urlencoded'
      'content-type': 'application/json',
      Authorization: 'Bearer ' + this.lbriAPI.access_token,
    });

    let options = {
      headers: headers,
    };

    let _body = {
      FirstNameOnCard: first,
      LastNameOnCard: last,
      StreetAdd: street,
      Zip: zip,
      CreditCardNumber: cc,
      ExpDateMonth: month,
      ExpDateYear: year,
      CVVcode: cvv,
      Amount: amount,
    };

    return this._http
      .post(this._CCPaymentUrl + currentOrderID.ID, _body, options)
      .pipe(
        tap((res) => {
          localStorage.setItem('completedOrderId', JSON.stringify(res));
        }),
        catchError(this.handleError)
      );
  }

  static creditCardValidator(control: any) {
    // Visa, MasterCard, American Express, Diners Club, Discover, JCB
    if (
      control.value.match(
        /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/
      )
    ) {
      return null;
    } else {
      return { invalidCreditCard: true };
    }
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(() => new Error(errorMessage));
  }
  handleErrorNexio(error: HttpErrorResponse) {
    let errorMessage = 'Unknown error!';
    console.log(error.error);
    if (error.error instanceof ErrorEvent) {
      // Client-side errors
      errorMessage = `Error: ${error.error.message}`;
    } else {
      // Server-side errors
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    //window.alert(errorMessage);
    return throwError(error.error.message);
  }
}
